import React from 'react';

const Spinner = ({ color, style, className = '' }) => (
  <div
    role="status"
    className={`spinner-border${color ? ` text-${color}` : ''}${className ? ` ${className}` : ''}`}
    style={style}>
    <span className="visually-hidden">Loading...</span>
  </div>
);

export default Spinner;
